import { useQuery } from '@tanstack/react-query';
import useApiStore from '../../store/useApiStore';
import { ICampaign } from '../../types';
import { CAMPAIGNS_KEY } from '../../utils/constants';
import Api from '../Api';

export default function useGetCampaign(id: string) {
  const { onError } = useApiStore();

  return useQuery<ICampaign, Error>({
    queryKey: [CAMPAIGNS_KEY, id],
    queryFn: async () => {
      const api = new Api({ onError });

      const data: ICampaign = await api.get({
        url: `api/v1/campaigns/${id}`,
      });

      return data;
    },
  });
}
